<div
  class="header pb-7 pt-5 pt-lg-7 d-flex align-items-center"
  style="
    min-height: 120px;
    background-size: cover;
    background-position: center top;
  "
>
  <span class="mask bg-gradient-primary opacity-8"></span>
  <div class="container-fluid d-flex align-items-center">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <h1 class="text-white">Empresas</h1>
        <p class="text-white mt-0 mb-5">Empresas cadastradas em companies</p>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid mt--7">
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <div class="card shadow">
        <div class="table-responsive companies-table-wrap">
          <table class="table align-items-center table-flush companies-table">
            <thead class="thead-light">
              <tr>
                <th scope="col">Empresa</th>
                <th scope="col" class="d-none d-lg-table-cell">Categoria</th>
                <th scope="col" class="d-none d-md-table-cell">Tipo</th>
                <th scope="col" class="d-none d-xl-table-cell">Cashback</th>
                <th scope="col" class="d-none d-xl-table-cell">App</th>
                <th scope="col">Status</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of items$ | async">
                <th scope="row" class="company-cell">
                  <div class="media align-items-center">
                    <span class="avatar avatar-sm rounded-circle mr-3 flex-shrink-0">
                      <img
                        alt=""
                        [src]="
                          item?.foto ||
                          'https://ionicframework.com/docs/demos/api/avatar/avatar.svg'
                        "
                      />
                    </span>
                    <div class="media-body">
                      <span class="mb-0 text-sm font-weight-bold company-name">
                        {{ item?.nomeFantasia || "—" }}
                      </span>
                      <small class="text-muted company-meta">
                        {{ formatCnpj(item?.cnpj || item?.cpf) }}
                      </small>
                      <small class="text-muted company-meta">
                        {{ item?.email || "—" }}
                      </small>
                      <small class="text-muted company-meta" *ngIf="!item?.isOnline">
                        {{ item?.municipio }}{{ item?.uf ? "/" + item?.uf : "" }}
                      </small>
                      <small class="text-muted company-meta" *ngIf="item?.isOnline">
                        Sem local físico
                      </small>
                    </div>
                  </div>
                </th>
                <td class="col-categoria d-none d-lg-table-cell">{{ item?.categoria || "—" }}</td>
                <td class="d-none d-md-table-cell">
                  <span
                    class="badge badge-pill"
                    [class.badge-info]="item?.isOnline"
                    [class.badge-default]="!item?.isOnline"
                  >
                    {{ item?.isOnline ? "Virtual" : "Física" }}
                  </span>
                </td>
                <td class="d-none d-xl-table-cell">
                  {{ item?.cashbackPercentual }}%
                  <br />
                  <small class="text-muted"
                    >lim. R$ {{ item?.limiteCompra | number : "1.0-2" }}</small
                  >
                </td>
                <td class="d-none d-xl-table-cell">
                  <span
                    class="badge badge-pill"
                    [class.badge-success]="isVisible(item)"
                    [class.badge-warning]="!isVisible(item)"
                    [title]="
                      isVisible(item)
                        ? 'Visível no app (geo ou categoria)'
                        : 'Invisível: falta geo e categoria'
                    "
                  >
                    {{ isVisible(item) ? "Visível" : "Incompleto" }}
                  </span>
                  <br *ngIf="!item?.isOnline" />
                  <small class="text-muted" *ngIf="!item?.isOnline">
                    {{ formatGeo(item) }}
                  </small>
                </td>
                <td>
                  <span
                    class="badge badge-pill"
                    [class.badge-success]="item?.status === 1"
                    [class.badge-danger]="item?.status !== 1"
                  >
                    {{ item?.status === 1 ? "Ativa" : "Inativa" }}
                  </span>
                </td>
                <td class="text-right company-actions">
                  <a
                    [routerLink]="['/empresa/cadastro', item?.id]"
                    class="btn btn-sm btn-secondary"
                    title="Editar"
                    ><i class="ni ni-ruler-pencil"></i
                  ></a>
                  <a
                    href="javascript:void(0)"
                    class="btn btn-sm"
                    [class.btn-danger]="item?.status === 1"
                    [class.btn-success]="item?.status !== 1"
                    (click)="toggleStatus(item)"
                    [title]="item?.status === 1 ? 'Desativar' : 'Ativar'"
                  >
                    <i class="ni ni-fat-remove" *ngIf="item?.status === 1"></i>
                    <i class="ni ni-check-bold" *ngIf="item?.status !== 1"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer py-4">
          <nav aria-label="...">
            <ul class="pagination justify-content-end mb-0">
              <li class="page-item">
                <button
                  class="page-link"
                  (click)="prevPage()"
                  [disabled]="!companyService.hasPreviousPage"
                >
                  <i class="fas fa-angle-left"></i>
                  <span class="sr-only">Previous</span>
                </button>
              </li>
              <li class="page-item">
                <button
                  class="page-link"
                  [disabled]="!companyService.hasNextPage"
                  (click)="nextPage()"
                >
                  <i class="fas fa-angle-right"></i>
                  <span class="sr-only">Next</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
